import React from "react";
import Layout from "components/common/Layout";
import { CourseCatalogQuery } from "components/courses/Catalog/CourseCatalog";
import CourseCatalogAuthors, {
  COURSE_CATALOG_AUTHORS_QUERY,
} from "components/courses/Catalog/CourseCatalogAuthors";
import { getServerSideSEO, SeoPageProps } from "helpers/seo";
import { withEnhancedServerSideProps } from "helpers/withEnhancedProps";

const CourseCatalogAuthorsPage = ({ title, seo }: SeoPageProps) => {
  return (
    <>
      <Layout initialMeta={seo}>
        <CourseCatalogAuthors title={title} />
      </Layout>
    </>
  );
};

export default CourseCatalogAuthorsPage;

const PAGE_TITLE = "Course Catalog by Author Name";

export const getServerSideProps = withEnhancedServerSideProps(async ctx => {
  if (ctx.isInitialRequest) {
    const seoProps = await getServerSideSEO(ctx, "course-catalog-authors", PAGE_TITLE);

    await ctx.apolloClient.query<CourseCatalogQuery>({
      query: COURSE_CATALOG_AUTHORS_QUERY,
    });

    return {
      props: seoProps,
    };
  }

  return {
    props: { title: PAGE_TITLE },
  };
});
